// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pl22H","field":"styles_field__GA3iF","fieldCol":"styles_fieldCol__2v3cz","diffCol":"styles_diffCol__dfr4_","diff":"styles_diff__4t9rk"};